import VulView from "./VulView";
import Organization from "./Organization";
import ItemUpdateProfile from "./ItemUpdateProfile";
import {UpdatedItemsBehaviour} from "./UpdatedItemsBehaviour";

class VulReportDefinition {
    constructor(
        public id?: string,
        public createdAt?: Date,
        public name?: string,
        public organization?: Organization,
        public vulViews?: VulView[],
        public times?: string[],
        public days?: string[],
        public timeZone?: string,
        public enabled?: boolean,
        public generateEmptyReport?: boolean,
        public autoGenerateAiSummary?: boolean,
        public reportUpdatedItemsBehaviour?: UpdatedItemsBehaviour,
        public itemUpdateProfile?: ItemUpdateProfile,
        public email?: string,
        public aiReportSummarizer?: {id: string; name: string}) {
        //
    }

    public static fromPOJO(data: any) {
        if (!data) return null;

        const definition = new VulReportDefinition();

        definition.id = data.id;
        definition.createdAt = new Date(data.createdAt);
        definition.name = data.name;
        definition.organization = (data.organization) ? Organization.fromPOJO(data.organization) : undefined;
        definition.vulViews = (data.vulViews) ? data.vulViews.map(value => VulView.fromPOJO(value)) : [];
        definition.times = data.times;
        definition.days = data.days;
        definition.timeZone = data.timeZone;
        definition.enabled = data.enabled;
        definition.generateEmptyReport = data.generateEmptyReport;
        definition.autoGenerateAiSummary = data.autoGenerateAiSummary;
        definition.aiReportSummarizer = data.aiReportSummarizer;
        definition.reportUpdatedItemsBehaviour = data.reportUpdatedItemsBehaviour;
        definition.itemUpdateProfile = ItemUpdateProfile.fromPOJO(data.itemUpdateProfile);
        definition.email = data.email;

        return definition;
    }

}

export default VulReportDefinition;
